import { TVContext } from "../hub/context";
import * as TradingView from '../charting_library';
import { TVSyncer } from "./sync";
import { TVSyncerTool } from "./syncitem";
import { hub } from "../hub";
import { AutoScaleReset } from "../config/general-config";
import { isSet } from "../storage";

export class ViewPortSync extends TVSyncerTool {
    private changing = false;
    private resetScale = AutoScaleReset.Never;
    private saving = false;
    constructor(syncer: TVSyncer, tvd: TVContext) {
        super(syncer, tvd);
    }

    private onViewPortChanged(resetScale: AutoScaleReset) {
        if (resetScale != AutoScaleReset.Never)
            this.resetScale = resetScale;
        if (this.changing)
            return;
        try {
            this.changing = true;
            setTimeout(() => {
                this.changing = false;
                if (this.resetScale != AutoScaleReset.Never)
                    this.resetAutoScale(this.resetScale);
                this.resetScale = AutoScaleReset.Never;
                this.tvd.smpa?.onViewPortChanged();
            }, 50);
        } catch (e) { console.error(e); }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    override onInit() {

        this.tvd.iframe.contentWindow.addEventListener("wheel", () => this.onViewPortChanged(AutoScaleReset.Scroll), true);
        this.tvd.iframe.contentWindow.addEventListener("gesturestart", (e) => {
            if (this.tvd.isAutoScale)
                this.tvd.iframe.contentWindow.setTimeout(() => this.resetAutoScale(AutoScaleReset.Scroll), 5);
        }, true);
        let mousedPressed = false;
        let y = 0;
        this.tvd.iframe.contentWindow.addEventListener("pointerdown", (e) => {
            this.syncer.lock(this.tvd);
            if ((e.target as HTMLElement).parentElement.classList.contains("price-axis")) {
                y = e.y;
                mousedPressed = true;
                this.onViewPortChanged(AutoScaleReset.Click);
            }
        }, true);
        this.tvd.iframe.contentWindow.addEventListener("pointermove", (e) => {
            if (mousedPressed && y - e.y != 0)
                this.onViewPortChanged(AutoScaleReset.Never);
        }, true);
        this.tvd.iframe.contentWindow.addEventListener("pointerup", (e) => {
            if (mousedPressed) {
                mousedPressed = false;
                this.onViewPortChanged(AutoScaleReset.Never);
            }
            this.syncer.release(this.tvd);
        }, true);
        this.tvd.tv.subscribe(
            "mouse_down",
            () => {
                this.resetAutoScale(AutoScaleReset.Click);
            }
        );
        this.tvd.tv.subscribe(
            "series_properties_changed",
            () => {
                this.onViewPortChanged(AutoScaleReset.Never);
                //this.saveState();
            }
        );
        //this.tvd.tv.activeChart().onVisibleRangeChanged().subscribe(null, p => this.saveState());

    }

    //private saveState = () => {
    //	//if (this.saving)
    //	//	return;
    //	//try {
    //	//	this.saving = true;
    //	//	setTimeout(() => {
    //	//		this.saving = false;
    //	//		this.tvd.saveState();
    //	//	}, 50);
    //	//} catch (e) { console.error(e); }
    //}

    private resetAutoScale = (reason: AutoScaleReset) => {
        if (isSet(hub.config.general.viewPort.autoScaleReset, reason) && reason != AutoScaleReset.Never)
            this.tvd.setAutoScale(true, false);
    }
}
